module.exports = __webpack_public_path__ + "static/media/login-background.2f10ed2d.jpeg";